import { CommonKeys } from "../../common/enums";
import { ARTIKEL_LIST_TYPE, ARTIKEL_TYPE, FORMULAR_GROUP_ARTIKEL_TYPE } from "../../common/formular-group-types";

const FormularGroupArtikelSchema = {
    $id: "FormularGroupArtikelSchema",
    title: "FormularGroupArtikel Schema",
    type: "object",
    properties: {
        [CommonKeys.Type]: { const: FORMULAR_GROUP_ARTIKEL_TYPE },
        [CommonKeys.Label]: { type: "string", nullable: true },
        [CommonKeys.ID]: { type: "string", nullable: true },
        [CommonKeys.ShowLabel]: { type: "boolean", nullable: true },
        Artikel: { $ref: "FormularGroupArtikelArtikelSchema" }
    },
    required: [CommonKeys.Type, CommonKeys.Label, CommonKeys.ID, "Artikel"]
}

const FormularGroupArtikelArtikelSchema = {
    $id: "FormularGroupArtikelArtikelSchema",
    title: "FormularGroupArtikelArtikel Schema",
    type: "object",
    properties: {
        [CommonKeys.Type]: { const: ARTIKEL_LIST_TYPE },
        [CommonKeys.Values]: {
            type: "array",
            items: { $ref: "SingleArtikelSchema" }
        }
    }
}

const SingleArtikelSchema = {
    $id: "SingleArtikelSchema",
    title: "SingleArtikel Schema",
    type: "object",
    properties: {
        [CommonKeys.Type]: { const: ARTIKEL_TYPE },
        ArtikelID: { type: "string", nullable: true },
        ArtikelNr: { type: "string", nullable: true },
        Kurztext: { type: "string", nullable: true },
        Menge: { type: "number", nullable: true },
        Mengeneinheit: { type: "string", nullable: true },
        Preis: { type: "number", nullable: true },
        Aktion: { type: "number", nullable: true },
    }
}

export const FORMULAR_GROUP_ARTIKEL_SCHEMAS = [
    FormularGroupArtikelSchema,
    FormularGroupArtikelArtikelSchema,
    SingleArtikelSchema
]